import { FilterConfigBuilder } from '@juvare/common-data-table-ui/FiltersBar/utils';
import { UserDirectoryFilterData } from '@juvare/contact-management/ui/features/user-directory';
import { useExtendedCredentialingUserDirectoryFilters } from '@juvare/credentialing/ui/hooks';

export function useExtendedUserDirectoryFilters() {
    const { extendCredentialingFilters } = useExtendedCredentialingUserDirectoryFilters();

    const extendFilters = (builder: FilterConfigBuilder<UserDirectoryFilterData>) => {
        extendCredentialingFilters(builder);
    };

    return {
        extendFilters,
    };
}
